module.exports = __webpack_public_path__ + "img/temp_right.ed4f5a17.png";